export function SelectTemporada({
  temporadas,
  value,
  onChange,
}: {
  temporadas: { id: number; nombre: string; prioridad: number }[];
  value: number;
  onChange: (id: number) => unknown;
}) {
  return (
    <select
      className="temporada"
      name="temporada"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      {value == 0 && <option />}
      {Object.values(temporadas)
        .sort((a, b) => b.prioridad - a.prioridad)
        .map((t) => (
          <option key={t.id} value={t.id}>
            {t.nombre}
          </option>
        ))}
    </select>
  );
}
